import { isScriptFullyLoaded, markScriptFullyLoaded, onDocumentReady } from "../utils/dom"
import "./styles/_golf-links.scss"

const state = {
    elements: {}
}

function cacheState() {
    state.elements = {
        sectionLinks: document.querySelectorAll(".Golf-links--item[data-type='section']"),
    }
}

function attachEventListeners() {
    state.elements.sectionLinks.forEach(link => {
        link.addEventListener("click", onSectionLinkClick)
    })
}

function onSectionLinkClick(e) {
    e.preventDefault();
    const targetId = e.target.dataset.target;
    const targetSection = document.getElementById(targetId.replaceAll("#", ""));
    if (!targetSection) return;

    targetSection.scrollIntoView({behavior: "smooth", block: "start"});
}

function init() {
    const isLoadedBefore = isScriptFullyLoaded("golf-links");
    if (isLoadedBefore) return;
    markScriptFullyLoaded("golf-links");

    cacheState();
    attachEventListeners();
}

onDocumentReady(init)